/* file-upload.js  TinyMeTales S3 uploader 2025-05 -------------------------------- */
(() => {
  /* ====== 1. 固定値を環境に合わせて編集 ====== */
  const UPLOAD_API =
    "https://91tczp7f0e.execute-api.ap-northeast-1.amazonaws.com/prod/presign"; // presign API URL
  const ALLOWED_TYPES = ["image/jpeg", "image/png"];  // 拡張したい場合は追加
  const MAX_SIZE_MB = 8;                              // S3アップロード許容サイズ

  /* ====== 2. 要素取得 ====== */
  const fileInput  = document.querySelector("#tm-photo-input");
  const hiddenProp = document.querySelector("input[name='properties[_photo]']");
  const previewImg = document.querySelector("#tm-photo-preview");
  const addBtn     = document.querySelector("button[type='submit']");

  if (!fileInput || !hiddenProp) return;  // 商品ページ以外では何もしない

  /* ====== 3. 補助関数 ====== */
  const bytes = (mb) => mb * 1024 * 1024;
  const showErr = (msg) => alert(msg);    // 必要ならモーダルなどに差し替え可
  const toggleBtn = (enable) => addBtn && (addBtn.disabled = !enable);

  /* ====== 4. presign 取得 & S3 直アップロード ====== */
  async function uploadFile(file) {
    // -- 4-1. presign 取得 --
    const res = await fetch(UPLOAD_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: file.type })
    });
    if (!res.ok) throw new Error("presign API error");
    const { url, fields, key } = await res.json();

    // -- 4-2. multipart/form-data で S3 へアップロード --
    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
    formData.append("file", file);

    const up = await fetch(url, { method: "POST", body: formData });
    if (up.status !== 204) throw new Error("S3 upload failed");

    return `${url}${key}`; // アップロード後の公開 URL
  }

  /* ====== 5. ファイル選択イベント ====== */
  fileInput.addEventListener("change", async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // -- バリデーション --
    if (!ALLOWED_TYPES.includes(file.type)) {
      showErr("PNG または JPEG 画像を選択してください。");
      fileInput.value = "";
      return;
    }
    if (file.size > bytes(MAX_SIZE_MB)) {
      showErr(`画像サイズは最大 ${MAX_SIZE_MB} MB までです。`);
      fileInput.value = "";
      return;
    }

    toggleBtn(false);                 // アップロード完了までカートボタン無効
    try {
      const url = await uploadFile(file);
      hiddenProp.value = url;        // line-item property に URL セット
      previewImg && (previewImg.src = url); // 簡易プレビュー
    } catch (err) {
      console.error(err);
      showErr("アップロードに失敗しました。時間を置いて再試行してください。");
      hiddenProp.value = "";
      fileInput.value  = "";
    } finally {
      toggleBtn(true);
    }
  });
})();
